export default "__VITE_ASSET__CyMCyFt0__"